function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import styled from 'styled-components';
import * as IconSet from "../../../../icons/index.js";
import Icon from "../../../basic/Icon/Icon.js";
import { classes, FieldSizes, Indicators } from "../constants.js";
import { getIndicatorIconSize } from "../helpers.js";
/* Custom chevron icon that indicates if menu is open or closed */

export var StyledDropdownIndicator = styled(Icon).withConfig({
  componentId: "CL__sc-kb1ekm-0"
})(["color:var(--black);outline:none;margin-left:3px;transition:transform var(--hover-transition);[data-theme='dark'] &{color:var(--white);}&:focus-visible{background-color:var(--btn-color-focus);border-radius:var(--border-radius-round);box-shadow:inset 0 0 0 2px var(--btn-color-hover);color:var(--btn-color-active);}", " &{transform:rotate(180deg);}"], classes.controlOpen);
var DropdownIndicator = props => {
  var {
      selectProps
    } = props,
    restInnerProps = _extends({}, (_objectDestructuringEmpty(props.innerProps), props.innerProps));
  var fieldSize = selectProps.fieldSize || FieldSizes.MEDIUM;
  var menuPlacement = selectProps.menuPlacement || 'bottom';
  return /*#__PURE__*/React.createElement(StyledDropdownIndicator, _extends({
    "aria-hidden": true,
    component: menuPlacement === 'top' ? IconSet.ChevronUp : IconSet.ChevronDown,
    size: getIndicatorIconSize(fieldSize, Indicators.DROPDOWN),
    tabIndex: 0
  }, restInnerProps));
};
export default DropdownIndicator;